import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { BrowserMediaQueries, CssSelectors } from '../../../styles/styles';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {},
	tag: {
		':nth-child(1n)': {
			padding: '2px 6px 2px 0',
		},
	},
	sectionWrap: {
		borderBox: 'box-sizing',
		alignItems: 'center',
		display: 'flex',
		padding: 10,
		borderTop: `1px solid ${colors.border.main}`,
		borderBottom: `1px solid ${colors.border.main}`,
	},
	sectionTitle: {
		minWidth: 200,
		color: colors.primary.main,
		fontSize: 14,
		margin: 0,
	},
	sectionIcon: {
		marginRight: 8,
		height: 16,
		width: 16,
	},
	searchBox: {
		':nth-child(1n)': {
			boxSizing: 'border-box',
			margin: '5px 14px 0 0',
			padding: '3px 6px',
			...CssSelectors.allChildren(
				{
					fontSize: 12,
				},
				'input'
			),
			[BrowserMediaQueries.IE11]: {
				width: '72%',
			},
		},
	},
	searchIcon: {
		marginRight: 8,
		marginTop: 5,
	},
	autocompleteBox: {
		width: 233,
		maxHeight: 304,
		overflowY: 'auto',
		overflowX: 'hidden',
		...CssSelectors.allChildren(
			{
				...CssSelectors.allChildren(
					{
						...CssSelectors.allChildren(
							{
								padding: '5px 10px',
							},
							'div'
						),
					},
					'div'
				),
				width: 205,
			},
			'div'
		),
	},
	noMargin: {
		margin: 0,
	},
	createTag: {
		display: 'block',
		padding: 10,
		fontSize: 14,
	},
});
